import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { Meta } from '@df/core/meta/meta';

@Component({
    selector: 'go-back',
    templateUrl: 'go-back.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoBackComponent {
    constructor(private meta: Meta, private router: Router) {}

    goBack(): void {
        if (this.meta.previousState) {
            window.history.back();
            return;
        }

        this.router.navigateByUrl('/');
    }
}
